import React, { memo } from 'react';
import { Box, useBreakpointValue, VStack } from 'native-base';
import EscrowDescription from '../EscrowDescription';
import StatementsLink from '../StatementsLink';
import SummaryTable from '../SummaryTable';
import CenteredSubTitle from '../CenteredSubTitle';
import OptionCardLayout from '../OptionCardLayout';
import { useIsDateBefore } from '../../../hooks';
const PAYMENT_OPTIONS_TITLE = `Payment options`;
const EscrowDetails = _ref => {
  let {
    data,
    onStatementsLinkClick,
    onPayNowClick,
    onLearnMoreClick
  } = _ref;
  const shouldShow = useIsDateBefore(data.effectiveDate);
  const direction = useBreakpointValue({
    base: 'column',
    lg: 'row'
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    px: {
      base: 0,
      md: 0,
      lg: 18
    },
    flexDirection: direction
  }, direction === 'column' ? /*#__PURE__*/React.createElement(Box, {
    my: "6",
    mx: {
      base: 0,
      md: 0,
      lg: 0
    }
  }, /*#__PURE__*/React.createElement(EscrowDescription, {
    onLearnMoreClick: onLearnMoreClick
  })) : /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement(EscrowDescription, {
    onLearnMoreClick: onLearnMoreClick
  })), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    my: 6,
    mx: {
      base: 0,
      md: 12,
      lg: 0
    }
  }, /*#__PURE__*/React.createElement(SummaryTable, {
    breakouts: data.breakouts,
    key: 'escrow-breakdown-table'
  }), /*#__PURE__*/React.createElement(StatementsLink, {
    onStatementsLinkClick: onStatementsLinkClick
  }))), /*#__PURE__*/React.createElement(Box, null, data.shortageOrSurplusAmount > 0 || !shouldShow ? null : /*#__PURE__*/React.createElement(VStack, {
    space: "2"
  }, /*#__PURE__*/React.createElement(CenteredSubTitle, {
    title: PAYMENT_OPTIONS_TITLE
  }), /*#__PURE__*/React.createElement(OptionCardLayout, {
    amountOne: data.optionOneAmount,
    amountTwo: data.optionTwoAmount,
    effectiveDate: data.effectiveDate,
    shortageOrSpread: data.shortageOrSurplusAmount,
    timeFrame: data.shortageSpread,
    onPayNowClick: onPayNowClick
  }))));
};
export default /*#__PURE__*/memo(EscrowDetails);
//# sourceMappingURL=index.js.map